export const LOGIN_REQUESTING = "LOGIN_REQUESTING";
export const LOGIN_WITH_FACEBOOK_REQUESTING = "LOGIN_WITH_FACEBOOK_REQUESTING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const LOGIN_CHANGE_PASSWORD = "LOGIN_CHANGE_PASSWORD";
export const LOGIN_CHANGE_EMAIL = "LOGIN_CHANGE_EMAIL";
export const FETCH_RESET_PASSWORD = "FETCH_RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

export const LOGOUT_STARTING = "LOGOUT_STARTING";
